import { useProductsContext } from "../../contexts";
import CategoryCard from "./CategoryCard";
import commonObj from '../../../utils/Common';


const CategoryList = ({ catRef }) => {
  const { categoryList } = useProductsContext();
  //console.log(categoryList,'fff');
  return (
    <>
      <h1 className="text-5xl md:text-4xl lg:text-5xl xl:text-6xl break-words text-center mt-10 font-extrabold">
        {commonObj.getLabel('Categories')}
      </h1>
      <section
        className="grid  grid-cols-1  md:grid-cols-3    gap-4  py-4 mt-1 "
        ref={catRef}
      >
        {categoryList?.list?.rows.map((categoryItem) => (
          <CategoryCard key={categoryItem?.id} category={categoryItem} url={categoryList?.url} />
        ))}
      </section>
    </>
  );
};

export default CategoryList;
